module.exports = __webpack_public_path__ + "static/img/icon-procedure.00991f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/article/icon-procedure.png
// module id = iHn6
// module chunks = 1